import React from 'react'
import { GoChevronDown } from 'react-icons/go'
import { FaPlus, FaMinus } from 'react-icons/fa'
import { FiExternalLink } from 'react-icons/fi'
import { Link } from 'react-router-dom'
import { useContext } from 'react'
import UserContext from '../../frontendTestContext/UserContext'
import { useState } from 'react'
import Footer from '../../components/footer/Footer'

const Shop = (props) => {
    const userContextUsed = useContext(UserContext)
    const shopData = userContextUsed.shop
    const cartData = userContextUsed.cart
    const productListX = shopData.products;
    const productList = productListX.map((product) => {
        const hasBeenAddedToCart = cartData.items.some(
        (item) => item.itemId === product.productDetailsFromBackend.productId);

            return {
                ...product,
                productDetailsFromBrowser: {
                ...product.productDetailsFromBrowser,
                hasBeenAddedToCart: hasBeenAddedToCart,
            },
        };
    });
    const sortedProducts = productList

    // const sortedProducts = shopData.products.sort(() => Math.random() - 0.5);
    // const sortedProducts = shopData.products.sort((a, b) => a.productDetailsFromBackend.productName.localeCompare(b.productDetailsFromBackend.productName));
    const [filter, setFilter] = useState("all")
    const filteredShop = sortedProducts.filter((product)=>{
        var userFinds = product
        if(filter === "all"){
            userFinds = product
        }
        else if(filter === "softwares"){
            userFinds = product.productDetailsFromBackend.productCategory === "Softwares"
        }
        else if(filter === "ebooks"){
            userFinds = product.productDetailsFromBackend.productCategory === "eBooks"
        }
        else if(filter === "songs"){
            userFinds = product.productDetailsFromBackend.productCategory === "Songs"
        }
        else if(filter === "videos"){
            userFinds = product.productDetailsFromBackend.productCategory === "Videos"
        }
        else if(filter === "courses"){
            userFinds = product.productDetailsFromBackend.productCategory === "Courses"
        }
        return userFinds
    })

    const shopItems = filteredShop.map((product)=>{
        const cartStatus = product.productDetailsFromBrowser.hasBeenAddedToCart
        const detailsFromBackend = product.productDetailsFromBackend
        // const detailsFromBrowser = product.productDetailsFromBrowser
        return (
            <div className="product" key={detailsFromBackend.productId}>
                <div className="top" style={{
                    backgroundImage: `linear-gradient(#0000, #000e), url(${detailsFromBackend.productUrls.productImgUrl})`,
                }}>
                    <Link onClick={()=>{
                      props.handleLoader(true, true)
                    }} to={`/product/${detailsFromBackend.productUrls.productUrl}`} className='product__link'>
                        <FiExternalLink />
                    </Link>
                    <div className="product-details">
                        <div className="product-name">
                            {detailsFromBackend.productName}
                        </div>
                        <div className="product-price">
                            ${detailsFromBackend.productPriceInDollar}
                        </div>
                    </div>
                </div>
                <div className={cartStatus ? "bottom in-cart" : "bottom"} onClick={()=>{
                    if (cartStatus){
                        props.removeFromCart(detailsFromBackend.productId)
                    }
                    else {
                        props.addToCart(detailsFromBackend.productId)
                    }
                }}>
                    {cartStatus ? <FaMinus />:
                    <FaPlus />}
                    <span>
                        {cartStatus ? "Remove from Cart": "Add to Cart"}
                    </span>
                </div>
            </div>
        )
    })
  return (
    <div className='shop'>
      <div className="content">
        <div className="heading">
          <h2>Shop</h2>
        </div>
        <div className="first-section">
          <div className="title">
            categories
          </div>
          <div className="current">
            {filter} <GoChevronDown />
            <div className="categories">
              <button onClick={()=>{
                setFilter("all")
              }}>
                All
              </button>
              <button onClick={()=>{
                setFilter("ebooks")
              }}>
                eBooks
              </button>
              <button onClick={()=>{
                setFilter("softwares")
              }}>
                Softwares
              </button>
              <button onClick={()=>{
                setFilter("songs")
              }}>
                Songs
              </button>
              <button onClick={()=>{
                setFilter("videos")
              }}>
                Videos
              </button>
              <button onClick={()=>{
                setFilter("courses")
              }}>
                Courses
              </button>
            </div>
          </div>
        </div>
        {shopItems.length > 0 ? <div className="second-section container">
          {shopItems}
        </div> : <div className="second-section container">
            <div className="failed">
                <h2>Check back Later for more <span style={{
                    color: "red"
                }}>"{filter}"</span> products</h2>
            </div>
        </div>}
        <Footer />
      </div>
    </div>
  )
}

export default Shop